'use strict';

import detail from './product/detail';
import giftCardDetail from './giftCard/giftCard';

const processInclude = require('base/util');

document.addEventListener('DOMContentLoaded', () => {
    processInclude(detail);
    processInclude(require('./components/pdpSwiperSlider'));
    processInclude(giftCardDetail);
});
